import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

import CloseSquare from '@shared/assets/icons/shared/close-square';
import { cn } from './helpers';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverClose = PopoverPrimitive.Close;

const PopoverContent = ({
  className,
  align = 'center',
  sideOffset = 4,
  withPortal = true,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content> & {
  withPortal?: boolean;
}) => {
  if (withPortal) {
    return (
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          align={align}
          sideOffset={sideOffset}
          onOpenAutoFocus={(e) => e.preventDefault()}
          onCloseAutoFocus={(e) => e.preventDefault()}
          className={cn(
            'z-50 w-72 rounded-md border border-primary-200 bg-white overflow-hidden p-4 text-gray-800 shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
            className
          )}
          {...props}
        />
      </PopoverPrimitive.Portal>
    );
  }
  return (
    <PopoverPrimitive.Content
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-50 w-72 rounded-md border border-primary-200 bg-white overflow-hidden p-4 text-gray-800 shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className
      )}
      {...props}
    />
  );
};

const PopoverHeader = ({
  className,
  children,
  ...props
}: React.ComponentProps<'div'>) => {
  return (
    <div
      className={cn(
        'flex text-gray-900 font-medium p-4 justify-between bg-primary-30',
        className
      )}
      {...props}
    >
      {children}
      <PopoverClose>
        <CloseSquare />
        <span className='sr-only'>Close</span>
      </PopoverClose>
    </div>
  );
};

export {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverAnchor,
  PopoverClose,
};
